module.exports = __webpack_public_path__ + "img/Icon_Youtube.12024352.svg";